export default __webpack_public_path__ + "static/media/anubhav.e89d7369.jpg";